import Guest from '@/layouts/guest';
import React, { useEffect } from 'react';
import FAQContent from "@/components/faq/content";
import { setCanonical } from '@/app/general';

const FAQ: React.FC = () => {
  useEffect(() => {
    setCanonical();
  }, []);
  
  return (
    <Guest title="سوالات متداول">
        <FAQContent />
    </Guest>
  );
}

export default FAQ;
